import { Toaster as Sonner } from 'sonner';
import { toastStyles } from './sonner-config';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: toastStyles.toast,
      }}
      {...props}
    />
  );
};

export { Toaster };
